import React, { RefObject } from 'react'
import { Col, Row, Select as SelectAntd } from 'antd'
import { FormikProps } from 'formik'

import { Id, RequestStandardSharing } from 'src/types'

import { InputNumber, SelectResource } from 'src/components/Formik'

type Props = {
  formikProps: FormikProps<
    | RequestStandardSharing
    | { request_standard_sharings: RequestStandardSharing[] }
  >
  index?: number
  organization_id: Id
  refCostCenterIdSelect?: RefObject<SelectAntd<string>>
}

function FormFields({
  formikProps,
  index,
  organization_id,
  refCostCenterIdSelect
}: Props): JSX.Element {
  return (
    <Row gutter={24}>
      <Col span={9}>
        <SelectResource
          autoFocus
          formikProps={formikProps}
          innerRef={refCostCenterIdSelect}
          keyLabel="name"
          keyValue="cost_center_id"
          label="web.assignment.sharing.form.cost-center.title"
          name={`${
            index >= 0 ? `request_standard_sharings.${index}.` : ''
          }cost_center_id`}
          organization_id={organization_id}
          placeholder="web.assignment.sharing.form.cost-center.placeholder"
          resource="cost_centers"
        />
      </Col>
      <Col span={9}>
        <SelectResource
          formikProps={formikProps}
          keyLabel="name"
          keyValue="contract_id"
          label="web.assignment.sharing.form.contract.title"
          name={`${
            index >= 0 ? `request_standard_sharings.${index}.` : ''
          }contract_id`}
          organization_id={organization_id}
          placeholder="web.assignment.sharing.form.contract.placeholder"
          resource="contracts"
        />
      </Col>
      <Col span={6}>
        <InputNumber
          dataTestId="sharing-percentage"
          formatter={value => `${value}%`}
          formikProps={formikProps}
          label="web.assignment.sharing.form.percentage.title"
          max={100}
          min={0}
          name={`${
            index >= 0 ? `request_standard_sharings.${index}.` : ''
          }percentage`}
          parser={value => value.replace('%', '')}
          placeholder="web.assignment.sharing.form.percentage.placeholder"
        />
      </Col>
    </Row>
  )
}

export default FormFields
